<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.danger500--text {{ $t('error') }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider
    div.py-6.px-10
      .text-md.mb-2 {{ $t('review_error_message') }}
      v-btn.button-sm.info500--text.pa-0(text small @click="showDetails = !showDetails") {{ showDetails ? 'hide' : 'show' }} details
      .text-sm.neutral500--text(:class="{ 'hidden':!showDetails }") {{ errorDetails }}
</template>

<script>
export default {
  name: 'ReviewErrorDialog',
  props: {
    open: {
      type: Boolean,
    },
    errorDetails: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDetails: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
  },
}
</script>

<style scoped>
.hidden {
  display: none;
}
</style>